const Card = {
  baseStyle: {
    p: "22px",
    display: "flex",
    flexDirection: "column",
    backdropFilter: "blur(40px) saturate(180%)",
    width: "100%",
    borderRadius: "20px",
    bg: "linear-gradient(127.09deg, rgba(6, 11, 40, 0.94) 19.41%, rgba(10, 14, 35, 0.69) 76.65%)",
    backgroundClip: "border-box",
    border: "1px solid rgba(255, 255, 255, 0.05)",
    boxShadow: "0 8px 32px 0 rgba(0, 0, 0, 0.37)",
    transition: "all 0.3s cubic-bezier(0.4, 0, 0.2, 1)",
    animation: "fadeIn 0.4s ease-out",
    _hover: {
      boxShadow: "0 12px 40px 0 rgba(139, 92, 246, 0.15)",
      border: "1px solid rgba(139, 92, 246, 0.1)",
    },
  },
  variants: {
    elevated: {
      boxShadow: "0 20px 60px 0 rgba(0, 0, 0, 0.5)",
      border: "1px solid rgba(255, 255, 255, 0.08)",
      _hover: {
        transform: "translateY(-2px)",
        boxShadow: "0 25px 70px 0 rgba(139, 92, 246, 0.2)",
      },
    },
    stat: {
      bg: "linear-gradient(135deg, rgba(6, 11, 40, 0.95) 0%, rgba(20, 25, 60, 0.8) 100%)",
      border: "1px solid rgba(139, 92, 246, 0.15)",
      position: "relative",
      overflow: "hidden",
      _before: {
        content: '""',
        position: "absolute",
        top: 0,
        left: 0,
        right: 0,
        height: "3px",
        bg: "linear-gradient(90deg, #8b5cf6, #06b6d4, #8b5cf6)",
        backgroundSize: "200% 100%",
        animation: "gradientShift 3s ease infinite",
      },
    },
    glass: {
      bg: "rgba(6, 11, 40, 0.6)",
      backdropFilter: "blur(20px) saturate(200%)",
      border: "1px solid rgba(255, 255, 255, 0.1)",
      boxShadow: "0 8px 32px 0 rgba(0, 0, 0, 0.2)",
    },
  },
};

export const CardComponent = {
  components: {
    Card,
  },
};
